import { QR_DIAGNOSTICS, ASC, DESC } from 'app/constants';
import QrDiagnostics from 'endpoints/qr-diagnostics';

const mapItem = (item) => {
  return {
    ...item,
    printer_model: item.printer_model || '',
    printer_serial: item.printer_serial || '',
    printer_commission_date: item.printer_commission_date || '',
    printer_country: item.printer_country || '',
    printer_language: item.printer_language || '',
    printer_language: item.printer_language || '',
    user_email: item.user_email || '',
    comment_on_device: item.comment_on_device || '',
    comment_on_backend: item.comment_on_backend || '',
    created_on_device: new Date(item.created_on_device),
    registered_on_backend: new Date(item.registered_on_backend),
    has_bde: item.has_bde || false,
    has_logs: item.has_logs || false,
  };
};

const getQrDiagnosticsDataThunk = () => async (dispath, getState) => {
  dispath(setQrDiagnosticsDataLoading(true));
  try {
    const { qrDiagnostics: { config } } = getState();
    const { reports, pagination } = await QrDiagnostics.getList(config);
    const data = reports.map(mapItem);

    dispath(setQrDiagnosticsList({ data, pagination }));
    dispath(setQrDiagnosticsDataLoading(false));
  } catch (error) {
    console.error('[getQrDiagnosticsDataThunk][error]:', error);
    dispath(setQrDiagnosticsDataLoading(false));
  }
};

const getQrDiagnosticsDataByIdThunk = (id) => async (dispath, getState) => {
  dispath(setQrDiagnosticsDataLoading(true));
  try {
    const response = await QrDiagnostics.getItem(id);
    const data = { ...response, report: mapItem(response.report) };

    dispath(setQrDiagnosticsItem(data));
    dispath(setQrDiagnosticsDataLoading(false));
  } catch (error) {
    console.error('[ERROR]:', error);
    dispath(setQrDiagnosticsDataLoading(false));
  }
};

const downloadQrDiagnosticXMLFileThunk = (id) => async (dispath, getState) => {
  try {
    const { xml, filename } = await QrDiagnostics.downloadXMLFileById(id);

    const pseudoelement = document.createElement('a');
    const blob = new Blob([xml], { type: 'text/plain' });

    pseudoelement.setAttribute('href', window.URL.createObjectURL(blob));
    pseudoelement.setAttribute('download', filename);

    pseudoelement.click();
  } catch (error) {
    console.error('[ERROR]:', error);
  }
};

const setQrDiagnosticsList = (payload) => {
  return {
    type: QR_DIAGNOSTICS.SET_LIST,
    payload,
  };
};

const setQrDiagnosticsItem = (payload) => {
  return {
    type: QR_DIAGNOSTICS.SET_ITEM,
    payload,
  };
};

const setQrDiagnosticsDataLoading = (payload) => {
  return {
    type: QR_DIAGNOSTICS.SET_LOADING,
    payload,
  };
};

const setQrDiagnosticsOffest = (payload) => {
  return {
    type: QR_DIAGNOSTICS.SET_PAGE_OFFSET,
    payload,
  };
};

const changeSortFieldThunk = (sortField) => (dispatch, getState) => {
  const { qrDiagnostics } = getState();
  const sort = sortField !== qrDiagnostics.config.sort_field ? { sort_field: sortField, sort_order: ASC } : { sort_order: qrDiagnostics.config.sort_order === ASC ? DESC : ASC };
  const payload = {
    ...qrDiagnostics,
    config: {
      ...qrDiagnostics.config,
      ...sort,
    },
  };

  dispatch(changeSortField(payload));
  dispatch(getQrDiagnosticsDataThunk());
};

const changeSortField = (payload) => {
  return {
    type: QR_DIAGNOSTICS.CHANGE_SORT_FIELD,
    payload,
  };
};

const resetToDefault = () => {
  return {
    type: QR_DIAGNOSTICS.RESET_TO_DEFAULT,
  };
};

const updateConfig = (data) => {
  return {
    type: QR_DIAGNOSTICS.UPDATE_CONFIG,
    payload: data
  };
};

export default {
  getQrDiagnosticsDataThunk,
  setQrDiagnosticsList,
  getQrDiagnosticsDataByIdThunk,
  downloadQrDiagnosticXMLFileThunk,
  setQrDiagnosticsOffest,
  resetToDefault,
  changeSortFieldThunk,
  updateConfig
};
